import { TCompany } from 'lib/models/company';

export function getCompanyMetaDescription(company: TCompany): string {
  const { name, short_description, description } = company;
  const pageDescription = short_description
    ? `${
        short_description.endsWith('.')
          ? short_description.trim()
          : `${short_description.trim()}.`
      } Find ${name} Jobs, Internships & Events.`
    : `Find ${name} Jobs, Internships & Events. ${description}`;
  const metaDescription =
    pageDescription.length <= 160
      ? pageDescription.trim()
      : `${pageDescription.substring(0, 157).trim()}...`;
  return metaDescription;
}
